import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "settings",
  "use": "settings-usage",
  "viewBox": "0 0 18 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 24\" id=\"settings\"><rect fill=\"currentColor\" x=\"8\" y=\"9\" width=\"2\" height=\"2\" rx=\"0\" /><rect fill=\"currentColor\" x=\"8\" y=\"15\" width=\"2\" height=\"2\" rx=\"0\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/settings.svg
// module id = dmzZ
// module chunks = 1